import { faBullseyeArrow, faLifeRing, faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

import './HeaderNavigationTopBar.css';

import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../context/auth-context';
import { LogoLinkButton } from './LogoLinkButton';
import { ProfileLinkButton } from './ProfileLinkButton';
import { TopNavItem } from './TopNavItem';
import { TopNavLibraryItem } from './TopNavLibraryItem';

type HeaderNavigationTopBarProps = {
  activeTabLabel: string;
  isMiddleBarVisible: boolean;
  logoButtonVisible?: boolean;
  changeMiddleBarVisibility: () => void;
};

export function HeaderNavigationTopBar({
  activeTabLabel,
  isMiddleBarVisible,
  logoButtonVisible = true,
  changeMiddleBarVisibility,
}: HeaderNavigationTopBarProps) {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const hasTags = auth?.tags.length > 0;
  const isAdmin = auth?.access === '10';
  const showInsideTabs = isAdmin || hasTags;

  const path = window.location.pathname;

  const isGoalPage = path.includes('goals');
  const isExplorePage = path.includes('explore');
  const isSupportPage = path.includes('support');

  return (
    <nav id="header-top-bar" aria-label={t('nav.page.topNavigationBar')}>
      <div className="logo-button-container">{logoButtonVisible && <LogoLinkButton />}</div>
      <div>
        <ul className="header-navigation-top-bar-links">
          {showInsideTabs && (
            <>
              <li>
                <TopNavLibraryItem
                  activeTabLabel={activeTabLabel}
                  isMiddleBarVisible={isMiddleBarVisible}
                  changeMiddleBarVisibility={changeMiddleBarVisibility}
                />
              </li>
              <li>
                <TopNavItem
                  isActive={isGoalPage}
                  icon={faBullseyeArrow}
                  label={t('nav.pages.goals').toUpperCase()}
                  href="/goals"
                />
              </li>
              <li>
                <TopNavItem
                  isActive={isExplorePage}
                  icon={faMagnifyingGlass}
                  label={t('nav.pages.explore').toUpperCase()}
                  href="/explore"
                />
              </li>
            </>
          )}

          <li>
            <TopNavItem
              isActive={isSupportPage}
              icon={faLifeRing}
              label={t('nav.pages.support').toUpperCase()}
              href="/support"
            />
          </li>
        </ul>
      </div>
      <div>
        <ProfileLinkButton />
      </div>
    </nav>
  );
}
